module.exports = "https://la-static.vkplay.ru/promo/newstart/img/lancemaster.04f1f0c7.png";